type FormatReviewCount = {
  value: number;
};

/**
 * Format review count to a human-readable string.
 * @param param0
 * @returns Formatted review count string.
 */
export const formatReviewCount = ({ value }: FormatReviewCount) => {
  if (value >= 1000) {
    return `${Math.round(value / 1000)}k+`;
  }

  return value.toString();
};
